import { cn as e } from "../../lib/utils.js";
import t from "../../_virtual/_@oxc-project_runtime@0.142.0/helpers/esm/objectWithoutProperties.js";
import n from "../../_virtual/_@oxc-project_runtime@0.142.0/helpers/esm/objectSpread2.js";
import * as r from "react";
import { jsx as i } from "react/jsx-runtime";
//#region src/components/primitives/highlight-serif.tsx
var a = [
	"tone",
	"className",
	"children",
	"style"
], o = { white: "var(--color-white)" }, s = r.forwardRef((r, s) => {
	let { tone: c = "ink", className: l, children: u, style: d } = r, f = t(r, a);
	return /* @__PURE__ */ i("em", n(n({
		ref: s,
		className: e("highlight-serif", l),
		style: c === "ink" ? d : n({ color: o[c] }, d)
	}, f), {}, { children: u }));
});
s.displayName = "HighlightSerif";
//#endregion
export { s as HighlightSerif };

//# sourceMappingURL=highlight-serif.js.map